import React, { useState } from "react";
import "../styles/navbar.css";
import logo from "../assets/logo.svg";

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => setIsOpen(prev => !prev);
  const closeMenu = () => setIsOpen(false);

  return (
    <header className="navbar-wrapper">
      <div className="navbar">

        {/* Logo */}
        <div className="navbar-left">
          <img src={logo} alt="Automitra Logo" />
        </div>

        {/* Desktop Links */}
        <nav className="navbar-center">
          <a href="#features">Features</a>
          <a href="#technology">Technology</a>
          <a href="#testimonials">Testimonials</a>
          <a href="#contact">Contact</a>
        </nav>

        {/* Desktop Buttons */}
        <div className="navbar-right">
          <button className="btn-outline">Sign In</button>
          <button className="btn-filled">Request Demo</button>
        </div>

        {/* Mobile Hamburger */}
        <div className="hamburger" onClick={toggleMenu}>
          {isOpen ? "✕" : "☰"}
        </div>
      </div>

      {/* Mobile Menu */}
      <div className={`mobile-menu ${isOpen ? "show" : ""}`}>
        <a href="#features" onClick={closeMenu}>Features</a>
        <a href="#technology" onClick={closeMenu}>Technology</a>
        <a href="#testimonials" onClick={closeMenu}>Testimonials</a>
        <a href="#contact" onClick={closeMenu}>Contact</a>

        <div className="mobile-buttons">
          <button className="btn-outline mobile-btn">Sign In</button>
          <button className="btn-filled mobile-btn">Request Demo</button>
        </div>
      </div>
    </header>
  );
};

export default Navbar;
